<p-sidebar
    [(visible)]="sidebarVisible"
    class="document-sidebar"
    position="right"
    [modal]="true"
    (onHide)="onCloseSidebar()"
    [styleClass]="'w-40rem'"
>
    <ng-template pTemplate="content">
        <section class="sidebar-section" [attr.aria-labelledby]="header ? 'table-summary-sidebar-title' : null"
            [attr.aria-label]="!header ? 'Table summary' : null">
            <h2 *ngIf="header" id="table-summary-sidebar-title">{{ header }}</h2>
            <h4 class="mb-3"> {{ documentName }} </h4>
            <ng-container *ngFor="let summary of [parsedSummaryData]; let i = index">
                <div markdown>
                    {{ summary }}
                </div>
            </ng-container>
        </section>
    </ng-template>
</p-sidebar>